import { Issue, IssueUrgency, urgencyOrder } from '@/models/Issue';

export const getHighestUrgency = (issues: Issue[]) => {
  if (!issues.length) {
    return null;
  }

  return issues.reduce(
    (highest, issue) =>
      urgencyOrder[issue.urgency] < urgencyOrder[highest] ? issue.urgency : highest,
    IssueUrgency.Low,
  );
};

export const getAverageIssueCost = (issue: Issue) =>
  Math.ceil(((issue.costEstimateMin ?? 0) + (issue.costEstimateMax ?? 0)) / 2);
